export default {
  list: { lazy: () => import('./Events'), component: 'EventList' },
  edit: { lazy: () => import('./Events'), component: 'EventEdit' },
  create: { lazy: () => import('./Events'), component: 'EventCreate' },
  options: {
    create: {
      title: 'Create Activity',
      subtitle: null,
      breadCrumb: 'Create Template',
    },
    list: {
      title: 'All Activities',
      subtitle:
        'View and add activities on this page. Activities help you to track the progress of your solar proposals.',
      breadCrumb: 'Activities',
    },
    edit: {
      title: 'Edit Activity',
      subtitle: null,
      breadCrumb: 'Edit Activity',
    },
  },
}
